import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "!flex-1" }

import slugify from 'slugify';
import { computed, reactive, Ref, ref, PropType, onMounted } from 'vue';
import { AxiosError } from 'axios';
import { ElNotification } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { uniq } from 'lodash';

import {
  getInspectionGroupReport,
  getInspectionGroupZip,
} from '@/entities/inspection-group/services';
import { useGetServiceQuery } from '@/entities/services/hooks';
import {
  useGetInspectionGroupQuery,
} from '@/entities/inspection-group/hooks';
import { useGetDeviceQuery, useGetNestedDevicesQuery } from '@/entities/device/hooks';

import { Device } from '@/entities/device/types';
import { InspectionGroup } from '@/entities/inspection-group/types';

import {
  NkForm,
  NkFormItem,
  NkButton,
  NkGroup,
  NkText,
  NkIcon,
  NkCheckbox, NkOption,
} from '@/core/components';

import AnnotationSeveritySelect
  from '@/entities/annotation-severity/components/inputs/AnnotationSeveritySelect.vue';
import AnnotationTypeSelect
  from '@/entities/annotation-type/components/inputs/AnnotationTypeSelect.vue';
import NkSelect from '@/core/components/overlays/Select/NkSelect.vue';
import { required } from '@vuelidate/validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionZIPForm',
  props: {
  inspectionGroup: {
    type: Number as PropType<InspectionGroup['id']>,
    required: true,
  },
},
  emits: ['submitted'],
  setup(__props, { emit }) {

const props = __props




const { t } = useI18n();

const form = ref();
const isLoading = ref(false);

const fields = reactive({
  annexes: false,
});

const rules = {
  annexes: {
    required,
  }
};

const inspectionGroupQueryData: Ref = computed(() => ({ id: props.inspectionGroup }));
const hasInspectionGroupQueryData = computed(() => !!inspectionGroupQueryData.value.id);
const { data: inspectionGroup } = useGetInspectionGroupQuery(inspectionGroupQueryData, {
  enabled: hasInspectionGroupQueryData,
});

const serviceQueryData: Ref = computed(() => ({ id: inspectionGroup.value?.service }));
const hasServiceQueryData = computed(() => !!serviceQueryData.value.id);
const { data: service } = useGetServiceQuery(serviceQueryData, { enable: hasServiceQueryData });

const isVolta = computed(() => service.value && slugify(service.value.name, { lower: true }).includes('volta'));
const isClarity = computed(() => service.value && slugify(service.value.name, { lower: true }).includes('clarity'));
const enabledAnnex = computed(() => isVolta.value || isClarity.value );

const handleZipDownload = () => {
  if (!isLoading.value) {
    form.value.validator.$validate().then((valid: boolean) => {
      if (valid) {
        isLoading.value = true;

        getInspectionGroupZip({
          ...fields,
          id: props.inspectionGroup,
        }).then((zip) => {
          window.open(zip, '_blank');
          emit('submitted');
        }).catch((e: AxiosError) => {
          ElNotification({
            type: 'error',
            title: (e?.response?.data as string) || t('inspection_group.notification.report_generation.error'),
            position: 'bottom-right',
          });
        }).finally(() => {
          isLoading.value = false;
        });
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkForm), {
    ref_key: "form",
    ref: form,
    fields: fields,
    rules: rules
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
            icon: "NkDownload",
            disabled: isLoading.value,
            onClick: handleZipDownload
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.save')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_loading, isLoading.value]
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(NkGroup), {
        spacing: 2,
        "no-wrap": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(NkIcon), { name: "NkInfo" })
          ]),
          _createVNode(_unref(NkText), { type: "semibold-xxs-keep" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('inspection.form.zip.filter_infos')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_unref(enabledAnnex))
        ? (_openBlock(), _createBlock(_unref(NkFormItem), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkCheckbox), {
                modelValue: fields.annexes,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.annexes) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('misc.annexes')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["fields"]))
}
}

})